import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  // Use this selector to auto-apply to every <input type="number">.
  // If you prefer manual opt-in, change to: selector: 'input[numbersOnly]'
  selector: 'input[type=number]'
})
export class NumbersOnlyDirective {
  private allowedKeys = [
    'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
    'ArrowLeft', 'ArrowRight', 'Home', 'End'
  ];

  constructor(private el: ElementRef<HTMLInputElement>) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const key = event.key;

    // ✔ Allow navigation/control keys
    if (this.allowedKeys.includes(key)) return;

    // ✔ Allow Ctrl/Cmd + A/C/V/X/Z
    if ((event.ctrlKey || event.metaKey) &&
        ['a','c','v','x','z','A','C','V','X','Z'].includes(key)) {
      return;
    }

    // ✔ Allow one decimal point BUT only one
    if (key === '.') {
      const value: string = this.el.nativeElement.value;
      if (value.includes('.')) {
        event.preventDefault(); // block second dot
      }
      return; // allow first dot
    }

    // ❌ Block: -, +, *, /, %, =, e, E, letters, symbols
    if (!/^[0-9]$/.test(key)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const pasted = event.clipboardData?.getData('text') ?? '';

    // Allow only valid decimal number format: e.g. 123, 12.34
    if (!/^\d*\.?\d*$/.test(pasted)) {
      event.preventDefault();
    }
  }

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent) {
    const text = event.dataTransfer?.getData('text') ?? '';

    if (!/^\d*\.?\d*$/.test(text)) {
      event.preventDefault();
    }
  }
}
